import { render, staticRenderFns } from "./audioCom.vue?vue&type=template&id=cdbe0d3e&scoped=true"
import script from "./audioCom.vue?vue&type=script&lang=js"
export * from "./audioCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbe0d3e",
  null
  
)

export default component.exports